<template>
  <div ref="strip" class="s-fleet">
    <div class="page-container">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <div class="s-fleet__header mb-40">
        <div class="h2">{{ dictionary.countryLabel }}</div>
        <div class="s-fleet__tools">
          <div class="s-fleet__countries">
            <select
              v-model="country"
              class="form-select"
              @change="onChangeCountry">
              <option
                v-for="item in countries"
                :key="item.value"
                :value="item.value">
                {{ item.text }}
              </option>
            </select>
          </div>
          <div class="s-fleet__my-filters">
            <span class="semibold">{{ dictionary.filtersLabel }}</span>

            <FleetFilters
              v-if="types.length"
              :key="keyFilters"
              :types="types"
              :vehicles-types="vehiclesTypes"
              :selected="selectedCategories"
              @submit-filters="onSubmitFilters" />
          </div>
        </div>
      </div>

      <div
        v-if="recordsCountFiltered"
        ref="grid"
        v-auto-animate
        class="s-fleet__grid mb-60">
        <div
          v-for="item in recordsFilteredPaged"
          :key="item.id"
          class="s-fleet__item">
          <Vehicle
            :key="key"
            :item="item"
            @book-fleet-vehicle="onBookFleetVehicle" />
        </div>
      </div>

      <div v-if="!recordsCountFiltered">
        <NoResults></NoResults>
      </div>

      <div v-if="recordsCountFiltered" class="d-flex justify-content-center">
        <Pagination
          class="mb-40"
          :total-records="recordsCountFiltered"
          :per-page="itemsPerPage"
          :current-page="page"
          @pagechanged="pageChanged" />
      </div>
    </div>

    <div class="page-container">
      <div class="s-fleet__footer">
        <button
          v-if="showButtonViewAll"
          type="button"
          class="btn btn-outline-primary"
          @click="onClickViewAll">
          {{ dictionary.buttonViewAllText }}
        </button>
      </div>
    </div>
  </div>

  <div
    id="modalVehicleForBooking"
    class="modal s-modal s-modal--success"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-check"></i></div>
            <div>{{ dictionary.modalVehicleForBookingTitle }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ formattedModalVehicleForBookingText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'
import * as lib from '../../lib/lib'
import axios from 'axios'
import Vehicle from '../components/Vehicle.vue'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import NoResults from '../components/common/NoResults.vue'
import FleetFilters from '../components/FleetFilters.vue'
import Pagination from './../components/common/Pagination.vue'
import { v4 as uuidv4 } from 'uuid'
/* eslint-disable no-unused-vars */
import { compact, uniqBy } from 'lodash'
import { Modal } from 'bootstrap'

export default {
  components: {
    FleetFilters,
    Alert,
    Loader,
    NoResults,
    Vehicle,
    Pagination,
  },
  data() {
    return {
      keyFilters: uuidv4(),
      key: uuidv4(),
      isLoading: false,
      errorMsgs: [],
      records: [],
      recordsCount: null,
      recordsFiltered: [],
      countries: [],
      country: '',
      types: [],
      page: 1,
      pageSize: 9,
      itemsPerPage: 0,
      selectedCategories: [],
      fetchDataFirstTime: true,
      vehiclesTypes: [],
      modalVehicleForBooking: null,
      modalTimeout: null,
      modalTimeoutDelay: 5000,
      vehicleForBookingGroup: null,
    }
  },
  computed: {
    showButtonViewAll() {
      return this.recordsCountFiltered > this.itemsPerPage
    },

    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage
      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },

    formattedModalVehicleForBookingText() {
      return this.dictionary.modalVehicleForBookingTextPrefix.replace(
        '{0}',
        this.vehicleForBookingGroup
      )
    },
  },
  mounted() {
    const { types, countries } = lib.getData('fleetData')
    this.types = types
    this.countries = countries
    this.itemsPerPage = this.configuration.itemsPerPage
    this.modalVehicleForBooking = new Modal(
      document.getElementById('modalVehicleForBooking')
    )
    this.setPreselectedOptions()
    this.setPreselectedValues()
    this.fetchData()
  },
  methods: {
    /* eslint-disable no-undef */
    setVehiclesTypes() {
      const arr = this.records.map((i) => i.Categories.split('|')).flat()
      const newArr = _.compact(arr)
      this.vehiclesTypes = _.uniqBy(newArr)
      this.keyFilters = uuidv4()
    },

    pageChanged(value) {
      this.page = value
      this.key = uuidv4()
      lib.scrollToElem(jQuery(this.$refs.grid), 100)
    },

    onClickViewAll() {
      this.page = 1
      this.itemsPerPage = 9999
    },

    onSubmitFilters(categories, transmissions, specialCategories) {
      this.page = 1

      this.key = uuidv4()

      if (!_.compact(categories).length) {
        lib.removeURLParameter('type')
        this.recordsFiltered = this.records
        return false
      }
      // https://stackoverflow.com/questions/16312528/check-if-an-array-contains-any-element-of-another-array-in-javascript
      this.recordsFiltered = this.records.filter((i) =>
        i.Categories.split('|').some((r) => categories.indexOf(r) >= 0)
      )

      this.appendFiltersToUrl(specialCategories)
    },

    appendFiltersToUrl(values) {
      const array = _.compact(values)

      if (!array.length) {
        return false
      }
      const paramValue = array.join(',')
      lib.appendUrlParam('type', paramValue)
    },

    setPreselectedOptions() {
      const entry = this.countries.find((i) => i.selected)
      this.country = entry ? entry.value : ''
    },

    setPreselectedValues() {
      const value = lib.getUrlParam('type', '')

      if (!lib.hasValue(value)) {
        return false
      }

      const array = decodeURIComponent(value).split(',')

      const entry = array.every((i) =>
        this.types.map((x) => x.CategoryId).includes(i)
      )

      if (!entry) {
        return false
      }

      this.selectedCategories = array
    },

    onChangeCountry() {
      lib.removeURLParameter('type')
      this.selectedCategories = []
      this.key = uuidv4()
      this.keyFilters = uuidv4()
      this.page = 1
      this.fetchData()
    },

    fetchData() {
      this.isLoading = true

      const postData = {
        countryCode: this.country,
      }
      axios
        .post(this.configuration.endpointFetchData, postData)
        .then((response) => {
          const { hasError, errorMessages, CarsView } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.records = this.recordsFiltered = CarsView
          this.recordsCount = this.records.length
          this.key = uuidv4()
          this.setVehiclesTypes()

          this.handleSuccess()

          if (this.fetchDataFirstTime) {
            this.onSubmitFilters(
              this.selectedCategories,
              [],
              this.selectedCategories
            )
            this.fetchDataFirstTime = !this.fetchDataFirstTime
          }
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
      this.$nextTick(() => {
        lib.scrollToError(150)
      })
    },

    onBookFleetVehicle(vehicle) {
      this.vehicleForBookingGroup = `Group ${vehicle.Name}`
      this.modalVehicleForBooking.show()

      clearTimeout(this.modalTimeout)

      setTimeout(() => {
        this.modalVehicleForBooking.hide()
      }, this.modalTimeoutDelay)
    },
  },
}
</script>
